
import { UnitOfMeasureModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { scrapCausesStore as unitOfMeasuresStore } from '@/libs/unit-of-measure/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import UnitOfMeasureDialog from '../components/UnitOfMeasureDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        UnitOfMeasureDialog,
    },
})
export default class UnitOfMeasures extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('unitOfMeasure.code'), value: 'code', align: 'left', sortable: false },
            { text: this.$i18n.t('unitOfMeasure.name'), value: 'name', align: 'left', sortable: false },
            { text: this.$i18n.t('unitOfMeasure.shortCode'), value: 'shortCode', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: UnitOfMeasureDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return unitOfMeasuresStore.useGetter(CrudGetter.Pending);
    }

    get items(): UnitOfMeasureModel[] {
        return [...unitOfMeasuresStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...unitOfMeasuresStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        unitOfMeasuresStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<UnitOfMeasureModel>(
            [
                { field: 'code', index: 1, order: 'asc' },
                { field: 'name', index: 2, order: 'asc' },
            ],
            this.getFilters()
        );
    }

    open(item: UnitOfMeasureModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }
}
